type MaybeApiError = {
  message?: string
  isCircuitOpen?: boolean
  cause?: {
    message?: string
    isCircuitOpen?: boolean
  }
}

export function isExpectedApiNetworkControlError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false
  }

  const candidate = error as MaybeApiError

  return (
    candidate.isCircuitOpen === true ||
    candidate.cause?.isCircuitOpen === true ||
    candidate.message?.includes('API circuit breaker is open') === true ||
    candidate.cause?.message?.includes('API circuit breaker is open') === true ||
    candidate.message?.includes('Refresh token request is cooling down after network failures') === true ||
    candidate.cause?.message?.includes('Refresh token request is cooling down after network failures') === true
  )
}

export function shouldCaptureApiErrorInSentry(error: unknown): boolean {
  return !isExpectedApiNetworkControlError(error)
}
